import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  bannersWrapper: {
    // 16px above the stack and 16px below it -- the last strip's own 8px margin and this 8px -- not a card's (LB-5968).
    paddingTop: '16px',
    paddingBottom: '8px',
    '&:empty': {
      display: 'none'
    }
  }
});
export default useStyles;